import * as React from 'react';
import Typography from '@mui/material/Typography';
import Stack from "@mui/material/Stack";
import {Box} from '@mui/material';

export default function Copyright(props: any) {
    return (
        <Box
            variant="body2"
            align="center"
            {...props}
            sx={[
                {
                    color: 'text.secondary',
                },
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        >

            <Stack alignItems={'center'} spacing={0.6} direction={'row'}>
                <Box sx={{cursor: 'pointer'}} onClick={() => {
                    window.open("https://beian.miit.gov.cn")
                }}>
                    {'Copyright © '} 渝ICP备2021005406号
                </Box>
                <Box component={'img'} src={'https://oss.kedaip.cn/keda/assets/beian.png'}></Box>
                <Box>
                    渝公网安备 50011202504074
                </Box>
            </Stack>

        </Box>
    );
}
